import React from 'react';
import { TouchableOpacity, Animated, ViewStyle, StyleProp } from 'react-native';

type ToggleSwitchProps = {
  value: boolean;
  style?: StyleProp<ViewStyle>;
  onValueChange: (value: boolean) => void;
  testID?: string;
  circleWidth?: number;
  switchHeight?: number;
  switchWidth?: number;
  boxRadius?: number;
};
import { Box } from '@components/Restyle';
import theme from '@themes/theme';

const ToggleSwitch: React.FC<ToggleSwitchProps> = (props) => {
  const enabled = props.value;
  const circleWidth = props.circleWidth ?? 24;
  const switchWidth = props.switchWidth ?? 56;
  const switchHeight = props.switchHeight ?? 32;
  const boxRadius = props.boxRadius ?? theme.borderRadii.m;
  const AnimatedBox = Animated.createAnimatedComponent(Box);
  return (
    <TouchableOpacity
      activeOpacity={1}
      onPress={() => {
        props.onValueChange(!enabled);
      }}
      testID={props.testID}
      style={props.style && []}>
      <AnimatedBox
        width={switchWidth}
        height={switchHeight}
        alignItems='center'
        flexDirection='row'
        style={{
          borderRadius: boxRadius,
          backgroundColor: enabled
            ? theme.colors.greenSecondary
            : theme.colors.grey03,
        }}>
        <AnimatedBox
          width={circleWidth}
          height={circleWidth}
          backgroundColor='background'
          style={{
            borderRadius: circleWidth / 2,
            marginRight: (switchHeight - circleWidth) / 2,
            marginLeft: enabled
              ? switchWidth - (switchHeight - circleWidth) / 2 - circleWidth
              : (switchHeight - circleWidth) / 2,
          }}
        />
      </AnimatedBox>
    </TouchableOpacity>
  );
};
export default ToggleSwitch;
